import { Events } from '|>/shared/events'
import { bind_, UPDATE_REFRESH_INTERVAL } from '|>/shared/fn'
import { on, register } from '|>/shared/vjs'
import { BaseComponent } from '../base'

/**
 * Current Time Updater component
 * Updates current time of the player to synchronize counters
 */
@register
export class CurrentTimeUpdater extends BaseComponent {
  private updateIntervalId: number | null = null

  constructor(player, options) {
    super(player, options)
    this.updateCurrentTime = bind_(this, this.updateCurrentTime)
  }

  @on('play')
  onPlay() {
    if (this.updateIntervalId) return
    this.updateIntervalId = this.setInterval(
      this.updateCurrentTime,
      UPDATE_REFRESH_INTERVAL
    )
  }

  @on(['pause', 'ended', 'dispose', 'error'])
  onStop() {
    this.clearInterval(this.updateIntervalId!)
    this.updateIntervalId = null
  }

  private updateCurrentTime() {
    const player = this.player_

    if (!player?.currentTime || player.isDisposed?.()) return

    player.trigger(Events.Media.TimeUpdate, player.currentTime())
  }
}
